import React from 'react';
import cx from 'classnames';
import { Field } from 'redux-form';

import { ImageUploadField } from 'helpers/redux/form';
import { node, string, number } from 'prop-types';

export default class ImageUploadInputField extends React.Component {
  static propTypes = {
    name: string.isRequired,
    title: node.isRequired,
    labelClassName: string,
    height: number.isRequired,
    width: number.isRequired,
    pickerWidth: number,
    filePickerApiKey: string.isRequired
  };
  static defaultProps = {};

  render() {
    const { width, height } = this.props;

    return (
      <fieldset>
        <label
          className={this.props.labelClassName}
          style={{ display: 'block' }}
        >
          {this.props.title}
        </label>
        <label
          className={cx(this.props.labelClassName, 'mui--text-caption')}
          style={{ margin: '5px 0 10px' }}
        >
          Recommended image size: {width}x{height} .png or .jpg
        </label>
        <Field
          name={this.props.name}
          component={ImageUploadField}
          height={this.props.height}
          width={this.props.width}
          pickerWidth={this.props.pickerWidth}
          apiKey={this.props.filePickerApiKey}
        />
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/formFields/ImageUploadInputField/index.js